export var ActionRequiredDetails;
(function (ActionRequiredDetails) {
    ActionRequiredDetails["CloudResourceActionRequiredUnspecified"] = "CLOUD_RESOURCE_ACTION_REQUIRED_UNSPECIFIED";
    ActionRequiredDetails["AzureSqlVmInvalidConfiguration"] = "AZURE_SQL_VM_INVALID_CONFIGURATION";
    ActionRequiredDetails["DynamoDbInvalidStreamViewType"] = "DYNAMO_DB_INVALID_STREAM_VIEW_TYPE";
    ActionRequiredDetails["DynamoDbInsufficientRcus"] = "DYNAMO_DB_INSUFFICIENT_RCUS";
    ActionRequiredDetails["RdsDatabaseStopped"] = "RDS_DATABASE_STOPPED";
    ActionRequiredDetails["BigqueryChangeHistoryDisabled"] = "BIGQUERY_CHANGE_HISTORY_DISABLED";
    ActionRequiredDetails["ObjectStoreInventoryRequired"] = "OBJECT_STORE_INVENTORY_REQUIRED";
    ActionRequiredDetails["CloudSqlDatabaseStopped"] = "CLOUD_SQL_DATABASE_STOPPED";
    ActionRequiredDetails["RdsGlobalDbSecondaryCluster"] = "RDS_GLOBAL_DB_SECONDARY_CLUSTER";
    ActionRequiredDetails["SapHanaBackupNotConfigured"] = "SAP_HANA_BACKUP_NOT_CONFIGURED";
    ActionRequiredDetails["KeyspacesCdcNotEnabled"] = "KEYSPACES_CDC_NOT_ENABLED";
    ActionRequiredDetails["AwsNativePitrPermissionsMissing"] = "AWS_NATIVE_PITR_PERMISSIONS_MISSING";
    ActionRequiredDetails["RdsManagedByExternalBackupPlan"] = "RDS_MANAGED_BY_EXTERNAL_BACKUP_PLAN";
    ActionRequiredDetails["SapHanaAgentApplicationNotOnboarded"] = "SAP_HANA_AGENT_APPLICATION_NOT_ONBOARDED";
    ActionRequiredDetails["KeyspacesInsufficientRcus"] = "KEYSPACES_INSUFFICIENT_RCUS";
})(ActionRequiredDetails || (ActionRequiredDetails = {}));
